<template>
   <v-dialog width="800px" :value="show" @input="$emit('close', $event)">
    <v-card height="535px">
      <v-card-text class="h-100 pb-0">
        <v-layout column h-100>
          <v-flex md1 mb-2>
            <v-layout row wrap>
              <filters-bar
                title="Agentes"
                title-class="headline"
                :hasDateType="true"
                title-box-size="md3"
                date-box-size="md4"
                :filtersButton="false"
                @search="getData"
                :filters="filters">
                <template slot="content">
                  <v-flex md2>
                    <v-btn
                      block
                      class="h-100 ma-0 w-100"
                      @click="generateReport">
                        <v-icon small>fas fa-download</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
              </filters-bar>
            </v-layout>
          </v-flex>
          <v-flex >
            <vue-perfect-scrollbar>
              <v-container id="scrollBar" fluid grid-list-md>
                <v-layout class="h-100" row wrap :class="{'align-center': data.length < 1 && !isSearching}">
                  <template v-if="isSearching">
                    <v-flex v-for="i in 12" :key="`agent-${i}`" md4>
                      <Skeleton-box flat>
                        <skeleton-line class="custom-line-skeleton"></skeleton-line>
                      </Skeleton-box>
                    </v-flex>
                  </template>
                  <template v-else>
                    <template v-if="data.length > 0">
                      <v-flex v-for="(user, i) in data" :key="`agent-${i}`" md4>
                        <div class="p-relative pa-2 custom-card">
                          <v-layout column>
                            <v-flex>
                              <v-layout row>
                                <v-flex md2 class="p-relative">
                                  <v-icon large>
                                    fas fa-user
                                  </v-icon>
                                  <v-icon class="user-status" :color="user.online === 1 ? 'green' : 'gray'" small>
                                    fas fa-comment-{{ user.online === 1 ? 'dots' : 'slash'}}
                                  </v-icon>
                                </v-flex>
                                <v-flex pl-4>
                                  <span class="name-span">
                                    {{user.first_name}} {{user.last_name}}
                                  </span>
                                  <span class="email-span">
                                    {{user.email}}
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex>
                              <v-layout row>
                                <v-flex md3>
                                  <span class="subtitle-1">
                                    {{ toHuman(Number(user.queued_time)) }}
                                  </span>
                                  <span class="custom-caption">
                                    Promedio de espera
                                  </span>
                                </v-flex>
                                <v-flex md3>
                                  <span class="subtitle-1">
                                    {{ toHuman(Number(user.unanswered_time)) }}
                                  </span>
                                  <span class="custom-caption">
                                    Promedio de respuesta
                                  </span>
                                </v-flex>
                                <v-flex md3>
                                  <span class="subtitle-1">
                                    {{ toHuman(Number(user.solved_time)) }}
                                  </span>
                                  <span class="custom-caption">
                                    Promedio de resolución
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex>
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex class="d-flex">
                              <v-progress-linear
                                color="linear-1"
                                style="border-radius: 0!important"
                                :style="`width: ${percentage(user.queued, user.total)}% !important`"
                                value="100" />
                              <v-progress-linear
                                color="linear-2"
                                style="border-radius: 0!important"
                                :style="`width: ${percentage(user.unanswered, user.total)}% !important`"
                                value="100" />
                              <v-progress-linear
                                color="linear-3"
                                style="border-radius: 0!important"
                                :style="`width: ${percentage(user.unsolved, user.total)}% !important`"
                                value="100" />
                              <v-progress-linear
                                color="linear-4"
                                style="border-radius: 0!important"
                                :style="`width: ${percentage(user.solved, user.total)}% !important`"
                                value="100" />
                            </v-flex>
                            <v-flex>
                              <v-layout row wrap>
                                <v-flex md3>
                                  <span class="square linear-1">
                                  </span>
                                  <span class="subtitule-1">
                                    {{ user.queued }}
                                  </span>
                                  <span class="custom-caption">
                                    En espera
                                  </span>
                                </v-flex>
                                <v-flex md3>
                                  <span class="square linear-2">
                                  </span>
                                  <span class="subtitule-1">
                                    {{ user.unanswered }}
                                  </span>
                                  <span class="custom-caption">
                                    Por responder
                                  </span>
                                </v-flex>
                                <v-flex md3>
                                  <span class="square linear-3">
                                  </span>
                                  <span class="subtitule-1">
                                    {{ user.unsolved }}
                                  </span>
                                  <span class="custom-caption">
                                    Por respuesta del cliente
                                  </span>
                                </v-flex>
                                <v-flex md3>
                                  <span class="square linear-4">
                                  </span>
                                  <span class="subtitule-1">
                                    {{ user.solved }}
                                  </span>
                                  <span class="custom-caption">
                                    Resueltos
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </template>
                    <v-flex v-else xs12 class="text-xs-center">
                      <span class="headline">
                        No hay información
                      </span>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </vue-perfect-scrollbar>
          </v-flex>
          <v-flex>
            <v-layout class="h-100 ma-0" justify-end align-end>
              <v-btn flat  @click="$emit('close', false)">Cerrar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import FiltersBar from '@/components/global/FiltersBar';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FiltersBar,
    SkeletonBox,
    SkeletonLine,
    VuePerfectScrollbar,
  },
  data() {
    return {
      filters: {
        dateType: 'date',
        date: moment().format('YYYY-MM-DD'),
      },
      data: [],
      isSearching: true,
      cancelToken: this.axios.CancelToken.source(),
    };
  },
  methods: {
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this.filters,
            filename: 'Chats por agentes',
          },
          functionName: 'chat_center_agents',
        },
      });
    },
    percentage(val, total) {
      return (val * 100) / total;
    },
    toHuman(time) {
      return moment.duration(time, 'seconds').humanize();
    },
    cancelGetData() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    getData() {
      this.isSearching = true;
      this.data = [];
      this.cancelGetData();
      this.axios.get('chat/center/agents/info', {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.filters,
        },
      }).then((res) => {
        for (let i = 0; i < res.data.length; i += 1) {
          this.$set(this.data, i, res.data[i]);
        }
      }).catch(() => {}).finally(() => {
        this.isSearching = false;
      });
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.getData();
      } else {
        this.cancelGetData();
      }
    },
  },
};
</script>
<style scoped>
.user-status {
  font-size: 16px;
  position: absolute;
  left: 2.5vw;
  top: 0;
}
.custom-line-skeleton {
  height: 30vh;
  border-radius: 0 !important;
}
.p-relative {
  position: relative;
}
.name-span, .email-span {
  display: block;
  line-height: 1;
}
.name-span {
  font-size: 20px;
  margin: 0;
  padding: 0;
  font-weight: 300;
}
.email-span {
  font-size: 10px;
  font-weight: 300;
}
.custom-caption {
  font-size: 9px;
  font-weight: 200;
  display: block;
  line-height: 1;
}
.custom-card {
  border: 1px solid #c7c4c4;
  box-shadow: 0px 0px 15px -2px #9e9e9e;
}
#scrollBar {
  height: 380px;
}
.progress-linear {
  height: 23px !important;
}
.square {
  width: 15px!important;
  height: 15px !important;
  background: #960b0b;
  display: inline-block;
}
#scrollBar >>> .linear-1 {
  border-radius: 0 !important;
  background-color: #4bdae7 !important;
  border-color: #4bdae7 !important;
}
#scrollBar >>> .linear-2 {
  border-radius: 0 !important;
  background-color: #fcae32 !important;
  border-color: #fcae32 !important;
}
#scrollBar >>> .linear-3 {
  border-radius: 0 !important;
  background-color: #f46860 !important;
  border-color: #f46860 !important;
}
#scrollBar >>> .linear-4 {
  border-radius: 0 !important;
  background-color: #65e4a1 !important;
  border-color: #65e4a1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/AgentsModal.vue